import AnayaCareHome from './Home'
import DocumentStatus from './DocumentStatus'
import { Navigate, Route, Routes } from 'react-router-dom'

const AnayaCareRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="home" />} />
      <Route path="home" Component={AnayaCareHome} />
      <Route path="document-status" Component={DocumentStatus} />
    </Routes>
  )
}

export default AnayaCareRoutes
